import MainRouter from './routers';
import IframeEventProvider from '@/context/IframeEventContext';
import ZustandModals from '@/components/common/ZustandModals';

function App() {
  return (
    <div className='App'>
      <IframeEventProvider>
        <MainRouter />
        <ZustandModals />
      </IframeEventProvider>
    </div>
  );
}

export default App;
